import React from "react";

const C5Envelope = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    viewBox="0 0 24.72 19.34"
  >
    <path
      fill="none"
      stroke=""
      strokeMiterlimit="10"
      d="M.5.5h23.72v18.34H.5z"
    />
    <path
      fill=""
      d="M3.27 4.97l8.94 6.02 9.23-6.02V3.62l-9.23 6.01-8.94-6.01z"
    />
  </svg>
);

export default C5Envelope;
